import { PeopleBar } from '../../../team/PeopleBar'

// The standard "See it as" bar in Nateva's words: Nateva Intelligence, its apps.
export function NatevaPeopleBar({ surfaceId }: { surfaceId?: string }) {
  return (
    <PeopleBar
      surfaceId={surfaceId}
      product="Nateva Intelligence"
      what="the apps they open and what they see. Nothing can be changed until you stop."
    />
  )
}
